import { render, staticRenderFns } from "./MdCommerce.vue?vue&type=template&id=51aa3a16&scoped=true&"
import script from "./MdCommerce.vue?vue&type=script&lang=js&"
export * from "./MdCommerce.vue?vue&type=script&lang=js&"
import style0 from "./MdCommerce.vue?vue&type=style&index=0&id=51aa3a16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51aa3a16",
  null
  
)

export default component.exports